import { Observable, of, throwError } from "rxjs";
import { delay, mergeMap, retryWhen } from "rxjs/operators";

export function delayedRetry(delayMs: number, retries: number, retryOnSpecificError?: string) {
    return (src: Observable<any>) =>
        src.pipe(
            retryWhen((errors: Observable<any>) => errors.pipe(
                delay(delayMs),
                mergeMap(e => {
                    if (retryOnSpecificError && e.error !== retryOnSpecificError) {
                        return throwError(e);
                    }
                    return --retries > 0 ? of(e) : throwError(e);
                })
            ))
        );
}
